module.exports = __webpack_public_path__ + "static/media/icon.56d87876.svg";